import { IQueryConfig } from "../types/server";

export const queryInitStatClientConfig: IQueryConfig = {
  retryCount: 3,
  debounceWait: 300,
  loadingDelay: 300,
  manual: false,
  pollingWhenHidden: false,
  pollingErrorRetryCount: 3,

};